import { render, staticRenderFns } from "./ResultD.vue?vue&type=template&id=86ba9ece&"
import script from "./ResultD.vue?vue&type=script&lang=js&"
export * from "./ResultD.vue?vue&type=script&lang=js&"
import style0 from "./ResultD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports